export default "__VITE_ASSET__ce918da9__"